<template>
  <v-row align="center" justify="center">
    <v-col cols="10">
      <v-progress-linear v-if="$apollo.loading" indeterminate />
      <highcharts v-if="dailyActiveUsersPerProduct" :options="dailyActiveUsersPerProductReport"></highcharts>
    </v-col>
  </v-row>
</template>

<script>
import { DAILY_ACTIVE_USERS_QUERY } from "@/graphql/queries/engagement.js";
export default {
  name: "DailyActiveUsers",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
    gymBranch: {
      type: [Number, String],
    },
  },
  data() {
    return {
      dailyActiveUsersPerProduct: null,
    };
  },
  computed: {
    dailyActiveUsersPerProductReport() {
      let series = this.dailyActiveUsersPerProduct.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Daily engaged users per product",
        },
        xAxis: {
          categories: this.dailyActiveUsersPerProduct[0].engagement.map((x) => x["actionDate"]),
        },
        yAxis: {
          title: {
            text: "# of engaged users",
          },
        },
        credits: {
          enabled: false,
        },

        series: series,
      };
    },
  },
  apollo: {
    dailyActiveUsersPerProduct: {
      query: DAILY_ACTIVE_USERS_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
          gymBranch: this.gymBranch,
        };
      },
    },
  },
};
</script>
